import React, { FC, PureComponent, PropsWithChildren } from "react";
import { FontIcon } from "react-toolbox/lib/font_icon";

import theme from "./theme.scss";

export interface RadioIconProps {
    badge?: string;
    checked?: boolean;
    children?: JSX.Element | JSX.Element[];
    disabled?: boolean;
    icon?: string;
    label?: string;
    description?: string;
    name: string;
    value: string;
    selectedOption?: string | undefined;
    handleChange?(name: string, value: string): void;
}

export const RadioIcon: FC<RadioIconProps> = (props: RadioIconProps) => {
    const id = `id_${props.value}`;
    const { badge, children, disabled, handleChange, icon, label, name, selectedOption, value } = props;
    const iconVal = icon ? icon : name.toLocaleLowerCase();
    const radioLabel = label || value;
    const isChecked = !!selectedOption && selectedOption.toLowerCase() === value.toLowerCase();

    function change() {
        if (disabled) {
            return false;
        }

        handleChange(name, value);
    }

    return (
        <li className={theme.item}>
            <input id={id} type="radio" name={name} value={value} onChange={change} checked={isChecked} />

            <label htmlFor={id}>
                <FontIcon value={iconVal} className={theme.icon} aria-hidden={true} />

                <p>{radioLabel}</p>
                {badge && <sup className={theme.badge}>{badge}</sup>}

                {children}
            </label>
        </li>
    );
};

export interface RadioIconGroupProps {
    ariaLabel: string;
    groupLabel?: string;
    selectedOption: string;
    onChange(key: string, value: string): void;
}

export interface RadioIconGroupState {
    selectedOption: string | undefined;
}



// export const RadioIconGroup: React.FC<RadioIconGroupProps> = (props) => {
//     const [selectedOption, setSelectedOption] = useState<string | undefined>(
//       props.selectedOption
//     );

//     const handleOptionChange = (selectedOption: string, value: string) => {
//       const { onChange } = props;
//       onChange(selectedOption, value);
//     };

//     return (
//       <div className={theme.wrap}>
//         {props.groupLabel && (
//           <p className={theme.groupLabel}>{props.groupLabel}</p>
//         )}
//         <ul
//           className={theme.list}
//           role="radiogroup"
//           aria-label={props.ariaLabel}
//         >
//           {React.Children.map(props.children, (child: JSX.Element) => {
//             if (child) {
//               return React.cloneElement(child, {
//                 handleChange: handleOptionChange,
//                 selectedOption,
//               });
//             }
//           })}
//         </ul>
//       </div>
//     );
//   };



export class RadioIconGroup extends PureComponent<PropsWithChildren<RadioIconGroupProps>, RadioIconGroupState> {
    constructor(props: RadioIconGroupProps) {
        super(props);

        this.state = {
            selectedOption: props.selectedOption
        };

        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    componentWillReceiveProps(newProps: RadioIconGroupProps) {
        const { selectedOption } = newProps;

        if (selectedOption) {
            this.setState({ selectedOption });
        }
    }

    handleOptionChange(selectedOption: string, value: string) {
        const { onChange } = this.props;

        onChange(selectedOption, value);
    }

    render() {
        return (
            <div className={theme.wrap}>
                {this.props.groupLabel && <p className={theme.groupLabel}>{this.props.groupLabel}</p>}
                <ul className={theme.list} role="radiogroup" aria-label={this.props.ariaLabel}>
                    {React.Children.map(this.props.children, (child: JSX.Element) => {
                        if (child) {
                            return React.cloneElement(child, {
                                handleChange: this.handleOptionChange,
                                selectedOption: this.state.selectedOption
                            });
                        }
                    })}
                </ul>
            </div>
        );
    }
}
